import React from 'react'
import { LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { Step1 } from './Step1'
import type { Step1Props } from './Step1'
import { Step1Legacy } from './Step1Legacy'

export const Step1Wrapper: React.FC<Step1Props> = props => {
  const isUnifiedMarkAllItemFulfillmentEnabled = getFeatureFromCache(
    LRX_41202_UC_IN_MARK_ALL_ITEM_FULFILLMENT
  )

  return isUnifiedMarkAllItemFulfillmentEnabled ? (
    <Step1 {...props} />
  ) : (
    <Step1Legacy {...props} />
  )
}

export { Step1Wrapper as Step1 }
export type { Step1Props }
